import { z } from 'zod';
// Icon glyph registry (§9, same shape as the animation/transition registries).
//
// An `icon` node cites a glyph by TOKEN; the renderer owns the vector art. That
// is deliberate and is the whole reason this is a closed list rather than an
// image URL: a glyph resolves synchronously at compile time to a name, so no
// asset fetch, no signing, no async resolution enters Phase B. (An arbitrary
// remote image WOULD need all of that — which is why the `media` node was
// deferred and why this registry is not a back door to it.)
//
// Adding a glyph:
//   1. Add the token here.
//   2. Add its path data to packages/remotion/src/registries/icon-glyphs.ts.
//
// The set is the social/checklist vocabulary the reel formats actually draw —
// v1's poll row chips (heart / comment bubble / paper plane) plus the marks a
// checklist or comparison row needs. Keep it small: every token is art someone
// has to draw and keep on-style.
export const ICON_GLYPHS = [
    'heart',
    'comment',
    'share',
    'check',
    'cross',
    'star',
    'clock',
    'arrow-right',
];
export const iconGlyphRef = z.enum(ICON_GLYPHS);
//# sourceMappingURL=icon-glyphs.js.map